var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8749_3230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8749_3230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 91.6666C40.3473 89.236 32.3786 83.6978 26.0938 75.052C19.8091 66.4062 16.6667 56.8055 16.6667 46.2499V20.8333L50.0001 8.33325L83.3334 20.8333V46.2499C83.3334 56.8055 80.1911 66.4062 73.9063 75.052C67.6216 83.6978 59.6529 89.236 50.0001 91.6666ZM41.6667 66.6666H58.3334C59.514 66.6666 60.5036 66.2673 61.3022 65.4687C62.1008 64.6701 62.5001 63.6805 62.5001 62.4999V49.9999C62.5001 48.8194 62.1008 47.8298 61.3022 47.0312C60.5036 46.2326 59.514 45.8333 58.3334 45.8333V41.6666C58.3334 39.3749 57.5174 37.4131 55.8855 35.7812C54.2536 34.1492 52.2917 33.3333 50.0001 33.3333C47.7084 33.3333 45.7466 34.1492 44.1147 35.7812C42.4827 37.4131 41.6667 39.3749 41.6667 41.6666V45.8333C40.4862 45.8333 39.4966 46.2326 38.698 47.0312C37.8994 47.8298 37.5001 48.8194 37.5001 49.9999V62.4999C37.5001 63.6805 37.8994 64.6701 38.698 65.4687C39.4966 66.2673 40.4862 66.6666 41.6667 66.6666ZM45.8334 45.8333V41.6666C45.8334 40.486 46.2327 39.4964 47.0313 38.6978C47.8299 37.8992 48.8195 37.4999 50.0001 37.4999C51.1806 37.4999 52.1702 37.8992 52.9688 38.6978C53.7674 39.4964 54.1667 40.486 54.1667 41.6666V45.8333H45.8334Z",
    fill: "#0000FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.57680da69608ec44870ec8905abf925c.svg";
export { ForwardRef as ReactComponent };